import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'


import i18n from './i18n/i18n.js'

const app = createApp(App)
// app.mixin({
//    methods: {
//       escapeHTML(value) {
//          return escapeHTML(value);
//       }
//    },
//    created() {
//       if (this.$options.computed) {
//          Object.keys(this.$options.computed).forEach(key => {
//             const originalComputed = this.$options.computed[key];
//             this.$options.computed[key] = function () {
//                const result = originalComputed.call(this);
//                return typeof result === 'string' ? this.escapeHTML(result) : result;
//             }
//          });
//       }
//    }
// })

app.use(i18n)

app.use(createPinia())
app.mount('#app')
